// Default page count for scenes with no page count
export const DEFAULT_PAGE_COUNT = 1.0;

// ─── metric selector ──────────────────────────────────────────────
export const METRIC_LABELS = {
  overall:       "Overall",
  pacing:        "Pacing",
  emotion:       "Emotion",
  originality:   "Originality",
  stakes:        "Stakes",
  characters:    "Characters"
};

/*
   Map <metric><→<node-type>> to the score key that lives in
   scores objects returned by the back-end.
*/
export const METRIC_KEYS = {
  overall:      { movie:"overallScore", act:"overallScore", sequence:"overallScore", scene:"execution" },
  pacing:       { movie:"pacing",       act:"pacing",       sequence:"pacing",       scene:"pacing_score" },
  emotion:      { movie:"emotionalImpact", act:"emotionalImpact", sequence:"emotionalImpact", scene:"emotional_impact" },
  originality:  { movie:"originality",  act:"originality",  sequence:"originality",  scene:"originality_score" },
  stakes:       { movie:"stakesHandling", act:"stakesHandling", sequence:"stakes",  scene:"highstakes" },
  characters:   { movie:"character",    act:"character",    sequence:"characterLeveragePoint", scene:"charactersrating" }
};


// Fallback for simple metric lookup (backwards compatibility)
export const SIMPLE_METRIC_TO_CATEGORY = {
  // Act metrics (keeping your original mapping as fallback)
  pacing: "Technical & Readability",
  emotionalImpact: "Emotional & Engagement", 
  originality: "Originality & Voice",
  stakesHandling: "Narrative Structure",
  character: "Character & Thematic Arcs"
};

// Updated color mapping based on ratings (0-3) with red to green spectrum
export const ratingColors = {
  0: "#FF3B30",
  1: "#FF9500", 
  2: "#7ED321",
  3: "#34C759"
};

export const gradeColors = {
  1: "rgba(255, 11, 11, 1)",
  2: "rgba(255, 11, 11, 0.85)",
  3: "rgba(255, 11, 11, 0.5)",
  4: "rgba(255, 11, 11, 0.3)",
  5: "rgba(255, 151, 11, 0.4)",
  6: "rgba(255, 151, 11, 0.3)",
  7: "rgba(11, 255, 11, 0.3)",
  8: "rgba(11, 255, 11, 0.5)",
  9: "rgba(11, 255, 11, 0.75)",
  10: "rgba(11, 255, 11, 1)"
};

export const borderRatingColors = {
  0: "#CC2F26",
  1: "#CC7700",
  2: "#65A91B", 
  3: "#2AA147"
};

export const ratingText = {
  0: "Pass",
  1: "Consider",
  2: "Recommend",
  3: "Highly Recommend"
};

export const BORDER_START = "#111111";
export const BORDER_ROOT = "#999999";
export const BORDER_SCENE = "#333333";
export const BORDER_WIDTH = 5;

export const badge = r => ["❌", "⚠️", "👍", "✅"][r] ?? "";
export const wrap  = str => str?.length > 50 ? str.slice(0, 50) + "…" : str;